import React from 'react';
import ReactEcharts from 'echarts-for-react';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import { useTheme } from '../../../../theme-context';

interface MonthlyData {
    month: number;
    label: string;
    positive: { count: number };
    neutral: { count: number };
    negative: { count: number };
}

interface IBarChart {
    data: MonthlyData[];
    xAxisData: string[]
}

const SentimentBarChart = ({ data, xAxisData }: IBarChart) => {
    const { theme } = useTheme();

    const positiveData = data?.map(d => d.positive.count);
    const neutralData = data?.map(d => d.neutral.count);
    const negativeData = data?.map(d => d.negative.count);

    const getOptionBar = () => ({
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            data: ['Positive', 'Neutral', 'Negative'],
            textStyle: {
                color: theme === 'dark' ? '#e4e4e4' : '#252B37'
            }
        },
        xAxis: {
            type: 'category',
            data: xAxisData
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                name: 'Positive',
                type: 'bar',
                stack: 'total',
                data: positiveData,
                color: '#10B981'
            },
            {
                name: 'Neutral',
                type: 'bar',
                stack: 'total',
                data: neutralData,
                color: '#F59E0B'
            },
            {
                name: 'Negative',
                type: 'bar',
                stack: 'total',
                data: negativeData,
                color: '#EF4444'
            }
        ]
    });

    return (
        <div>
            <ReactEcharts option={getOptionBar()} style={{ height: 400, width: '100%', marginTop: 20 }} />
        </div>
    );
};

export default SentimentBarChart;